module.exports = __webpack_public_path__ + "img/icon-word.0ec3a063.jpg";